
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[website]/[postID]",
      function () {
        return require("private-next-pages/[website]/[postID].tsx");
      }
    ]);
  